/* global bootstrap */
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "message"]

  connect() {
    this.activeForm = null
    this.activeSubmitter = null
    this.modal = null
    this._handleModalHide = this.handleModalHide.bind(this)

    if (this.hasModalTarget) {
      this.modal = new bootstrap.Modal(this.modalTarget)
      this.modalTarget.addEventListener("hide.bs.modal", this._handleModalHide)
    }
  }

  disconnect() {
    if (this.hasModalTarget) {
      this.modalTarget.removeEventListener("hide.bs.modal", this._handleModalHide)
      this.modal?.dispose()
    }
    this.activeForm = null
    this.activeSubmitter = null
    this.modal = null
    this._handleModalHide = null
  }

  intercept(event) {
    event.preventDefault()
    const trigger = event.currentTarget
    this.activeForm = trigger.form || trigger.closest("form")
    this.activeSubmitter = this.activeForm ? trigger : null

    if (trigger.dataset.submissionWarningMessage && this.hasMessageTarget) {
      const message = document.createElement("p")
      message.textContent = trigger.dataset.submissionWarningMessage
      this.messageTarget.replaceChildren(message)
    }

    this.showModal()
  }

  confirm() {
    const form = this.activeForm
    const submitter = this.activeSubmitter
    this.activeForm = null
    this.activeSubmitter = null
    this.hideModal()

    if (form) {
      if (typeof form.requestSubmit === "function") {
        form.requestSubmit(submitter)
      } else if (typeof form.submit === "function") {
        form.submit()
      }
    }
  }

  cancel() {
    this.hideModal()
    this.activeForm = null
    this.activeSubmitter = null
  }

  showModal() {
    if (this.modal) {
      this.modal.show()
    }
  }

  hideModal() {
    if (this.modal) {
      this.modal.hide()
    }
  }

  handleModalHide() {
    this.activeForm = null
    this.activeSubmitter = null
  }
}
